import React from 'react'
import { Helmet } from 'react-helmet'
import { useLocation } from 'react-router-dom'
import { generateAlternateLinks, generateTitleAndMetaTags } from 'src/utils/seo'

const SeoCsReleaseNotes = ({ title, description }) => {
  const { pathname } = useLocation()

  return (
    <Helmet>
      {generateTitleAndMetaTags(title, description)}
      {generateAlternateLinks(pathname)}
      <script type='application/ld+json'>
        {`{
            "@context": "https://schema.org/", 
            "@type": "BreadcrumbList", 
            "itemListElement": [
              {
                "@type": "ListItem", 
                "position": 1, 
                "name": "CounterSketch",
                "item": "https://gemvision.com/countersketch"
              },
              {
                "@type": "ListItem", 
                "position": 2, 
                "name": "CounterSketch Release Notes",
                "description": "Explore the latest CounterSketch updates to enhance your jewelry design experience.",
                "item": "https://gemvision.com/countersketch/release-notes"
              }
            ]
        }`}
      </script>
    </Helmet>
  )
}

export default React.memo(SeoCsReleaseNotes)
